import React from "react";
import { CollapsibleFormSection } from "../../common/CollapsibleFormSection";

interface PreventionStrategiesSectionProps {
  values: string[];
  otherValue: string;
  onCheckboxChange: (value: string, checked: boolean) => void;
  onOtherChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  className?: string;
}

const OPTIONS = [
  "Provide encouragement and build positive relationship",
  "Offer choices and control, e.g. 'Would you like to use pen or pencil?'",
  "Adjust tasks to skill level and provide scaffolding",
  "Give warnings before transitions and use timers to ease shifts",
  "Allow sensory or movement breaks through calming tasks/physical activity/sensory tools",
  "Use visual timetable",
  "Maintain a low level of clutter and noise",
  "Use first/then chart and visual aids",
  "Gently remind or prompt expected behaviours before transitions/known triggers",
];

export const PreventionStrategiesSection: React.FC<
  PreventionStrategiesSectionProps
> = ({ values, otherValue, onCheckboxChange, onOtherChange, className }) => (
  <CollapsibleFormSection
    title="Select/describe appropriate prevention strategies for the student at this stage:"
    className={className}
  >
    <div className="form-group checkbox-group brp-checkbox-group">
      {OPTIONS.map((option) => {
        const isSelected = values.includes(option);
        return (
          <label
            key={option}
            className={`checkbox-item brp-checkbox-item ${
              isSelected ? "selected" : ""
            }`}
          >
            <input
              type="checkbox"
              checked={isSelected}
              onChange={(e) => onCheckboxChange(option, e.target.checked)}
            />
            <span className="checkbox-custom brp-checkbox-custom"></span>
            <span className="checkbox-label">{option}</span>
          </label>
        );
      })}
    </div>
    <div className="brp-wide-input-container" style={{ marginTop: 16 }}>
      <label className="other-input-label" htmlFor="preventionStrategiesOther">
        Other:
      </label>
      <input
        type="text"
        id="preventionStrategiesOther"
        name="preventionStrategiesOther"
        value={otherValue}
        onChange={onOtherChange}
        className="other-input brp-wide-input"
      />
    </div>
  </CollapsibleFormSection>
);
